import floatBehavior from './floatBehavior';
import mobileAspect from './mobileAspect';
import seo from './seo';
import videoAdWatch from './videoAdWatch';

export { floatBehavior, mobileAspect, seo, videoAdWatch };
